var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h5',[_vm._v("Authenticated "),_c('ProgressBar',{attrs:{"disabled":_vm.isAnonymous,"percent":_vm.percent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }